import React from 'react';

const FloatingWhatsApp = () => {
  const handleWhatsAppClick = () => {
    // You can add WhatsApp link here
    window.open('https://wa.me/6281234567890', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button 
        onClick={handleWhatsAppClick}
        className="w-16 h-16 bg-green-500 text-white rounded-full shadow-2xl hover:bg-green-600 transition-all duration-300 hover:scale-110 flex items-center justify-center"
      >
        <i className="fa-brands fa-whatsapp text-2xl"></i>
      </button>
    </div>
  );
};

export default FloatingWhatsApp;

